export const calendarModuleSelectedCalendarsCollectorDescription = "v$SuGb";
export default {calendarModuleSelectedCalendarsCollectorDescription};